<template>
    <div id="content" v-show="!loading">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
            <h1 v-translate>Přidat profil zařízení</h1>
        </div>

        <div class="responsiveTabs">

            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileNewProperties'}"><a @click.stop="openRoute('deviceProfileNewProperties')" v-translate>Vlastnosti</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileNewProtocols'}"><a @click.stop="openRoute('deviceProfileNewProtocols')" v-translate>Nastavení protokolů</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileNewLinearProtocols'}"><a @click.stop="openRoute('deviceProfileNewLinearProtocols')" v-translate>Protokoly pro lineární obsah</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileNewNonLinearProtocols'}"><a @click.stop="openRoute('deviceProfileNewNonLinearProtocols')" v-translate>Protokoly pro nelineární obsah</a></li>
            </ul>

            <router-view
                :isEditable="isEditable"
                :entity="entity"
                :codecs="codecs"
                :protocols="protocols"
                :deviceTypes="deviceTypes"
                :streamProfiles="streamProfiles"
                :operatorOptions="operatorOptions"
                :operatorIdComputed="operatorIdComputed"
                @addProtocol="onAddProtocol"
            />

            <section class="buttons" v-if="isEditable">
                <p>
                    <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam profilů zařízení</router-link>
                    <input type="submit" :value="'Uložit' | translate"
                           :class="['btn']"
                           @click.prevent.stop="createEntity()">
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import deviceProfiles from "@/components/views/deviceProfiles/mixins/deviceProfiles"

export default {
    name: "DeviceProfileNew",
    mixins: [detailActions, deviceProfiles],
    data() {
        return {
            codecs: [],
            protocols: [],
            deviceTypes: [],
            streamProfiles: []
        }
    },
    created(DeviceProfileService, OperatorService) {
        this.entityService = DeviceProfileService;

        if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.operatorService = OperatorService
          this.getOperators().then(() =>{
            this.operators = [{'id': null, 'name': this.$gettext('Nenastaven')}, ...this.operators];
          });
        }

        this.getDependency().then(() => {
            this.loading = false;
        });
    },
    computed: {
        isEditable() {
            return true;
        },
    },
    methods: {
      _beforeCreateEntityActions(params){
        if(!params.id_operator){
          params.id_operator = this.$_loggedUser_selectedOperatorId;
        }
        return params;
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/DeviceProfileNew.vue